import { Banner } from '@/components/Banner/Banner';
import { languageStrings } from '@/l18n/de';
import { getSmartPlusPurUrl } from '@/lib/banner';
import { setInnerHTML } from '@/lib/util';

const BannerSmartPlusPur = () => {
	const ctaUrl = getSmartPlusPurUrl();
	const { heading, explanation } = languageStrings.smartPlusPurHint;

	return (
		<Banner className="banner-warning">
			<div className="banner--active-hint">
				<strong>{heading}</strong>
				<span dangerouslySetInnerHTML={setInnerHTML(explanation(ctaUrl))}></span>
			</div>
		</Banner>
	);
};

export { BannerSmartPlusPur };
